export default __webpack_public_path__ + "static/media/work-2.40732c80.png";